/**
* tested on Chrome, Safari (+IOS), Firefox, Edge, IE 10 & 11, Brave
*/

/**
* triggers a client-side file save tailored to user's browser.
* @param {string} data - data to be included in text file.
* @param {string} filename - name of file to be downloaded.
* @param {string} mimetype - mimetype of file to be downloaded.
*/

export function saveAs(data, filename, mimetype) {
	let handler = getHandler();
	if (handler) {
		return handler(data, filename, mimetype);
	}
}

// returns boolean if browser file download is compatible.
export const supported = () => !!getHandler();

/**
* checks for browser compatibility and returns appropriate fn to
* achieve client-side file download.
*/

function getHandler() {
	if (isIE() >= 9) return handleIE;
	if (isBlobCompat()) return handleBlobCompat;
}

/**
* HTML5 Download & Blob compatible browser downloads. Includes most modern
* browsers and is the preferred solution.
*/

const isBlobCompat = () => {
	return 'download' in document.createElement('a') && !!new Blob()
}

const handleBlobCompat = (data, filename, mimetype) => {
	let link = document.createElement('a');
	link.href = `data:attachment/${mimetype},${encodeURI(data)}`;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	setTimeout( () => document.body.removeChild(link) );
}

/**
* Microsoft Edge / Internet Explorer solution. Utilizes iframe, triggers
* download w/ filename but user must manually correct filetype.
*/

const isIE = () => {
	let ua = window.navigator.userAgent;

	// IE 10 or older => return version number
	let msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	// IE 11 => return version number
	let trident = ua.indexOf('Trident/');
	if (trident > 0) {
		let rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	// Edge (IE 12+) => return version number
	let edge = ua.indexOf('Edge/');
	if (edge > 0) {
		return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	return false;
}

const handleIE = (data, filename, mimetype) => {
	try {
		let ieData = new Blob([data], {type: mimetype});
		window.navigator.msSaveBlob(ieData, filename);
	}
	catch (e) {
		let frame = document.createElement('iframe');
		frame.style.cssText = 'position:absolute; left:0; top:-999px;';
		document.body.appendChild(frame);
		let doc = frame.contentWindow.document;
		doc.open("text/html", "replace");
		doc.write(data);
		doc.save="text";
		doc.execCommand('SaveAs', true, filename);
		doc.close();
		frame.focus();
		setTimeout(() => document.body.removeChild(frame), 1000);
	}
}